import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialMediaLinks = () => {
  const socialPlatforms = [
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      handle: '@edrianbass',
      followers: '12.5K',
      description: 'Professional network & IT insights',
      url: 'https://linkedin.com/in/edrianbass',
      color: '#0A66C2',
      gradient: 'from-[#0A66C2] to-[#004182]'
    },
    {
      name: 'Twitter',
      icon: 'Twitter',
      handle: '@edrianbass',
      followers: '8.3K',
      description: 'Tech thoughts & entrepreneurship',
      url: 'https://twitter.com/edrianbass',
      color: '#1DA1F2',
      gradient: 'from-[#1DA1F2] to-[#0C85D0]'
    },
    {
      name: 'Instagram',
      icon: 'Instagram',
      handle: '@edpulse_creative',
      followers: '15.2K',
      description: 'Creative direction & visual storytelling',
      url: 'https://instagram.com/edpulse_creative',
      color: '#E4405F',
      gradient: 'from-[#833AB4] via-[#E4405F] to-[#FCAF45]'
    },
    {
      name: 'GitHub',
      icon: 'Github',
      handle: '@edrianbass',
      followers: '2.1K',
      description: 'Open source projects & code',
      url: 'https://github.com/edrianbass',
      color: '#181717',
      gradient: 'from-[#181717] to-[#000000]'
    },
    {
      name: 'YouTube',
      icon: 'Youtube',
      handle: '@EdPulseCreative',
      followers: '5.7K',
      description: 'Tech tutorials & creative content',
      url: 'https://youtube.com/@edpulsecreative',
      color: '#FF0000',
      gradient: 'from-[#FF0000] to-[#CC0000]'
    },
    {
      name: 'TikTok',
      icon: 'Music',
      handle: '@edpulse',
      followers: '18.4K',
      description: 'Creative content & viral moments',
      url: 'https://tiktok.com/@edpulse',
      color: '#000000',
      gradient: 'from-[#000000] to-[#69C9D0]'
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      handle: 'Edrian Bass',
      followers: '9.8K',
      description: 'Community updates & events',
      url: 'https://facebook.com/edrianbass',
      color: '#1877F2',
      gradient: 'from-[#1877F2] to-[#0C5DBD]'
    }
  ];

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-lg border border-border">
      <div className="mb-6 md:mb-8">
        <h3 className="text-xl md:text-2xl font-semibold mb-2">Connect on Social Media</h3>
        <p className="text-sm md:text-base text-muted-foreground">
          Follow me across platforms for updates, insights, and creative content
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {socialPlatforms?.map((platform) => (
          <a
            key={platform?.name}
            href={platform?.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative overflow-hidden rounded-xl bg-muted hover:bg-muted/80 transition-all border border-border hover:border-primary p-5 md:p-6"
          >
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl bg-gradient-to-br ${platform?.gradient} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                <Icon name={platform?.icon} size={24} color="white" />
              </div>
              <Icon name="ExternalLink" size={16} color="var(--color-muted-foreground)" className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>

            <div className="space-y-2">
              <h4 className="text-lg font-semibold">{platform?.name}</h4>
              <p className="text-sm text-primary">{platform?.handle}</p>
              <p className="text-xs text-muted-foreground line-clamp-2">{platform?.description}</p>
              
              <div className="flex items-center gap-2 pt-2">
                <Icon name="Users" size={14} color="var(--color-muted-foreground)" />
                <span className="text-xs font-medium text-muted-foreground">{platform?.followers} followers</span>
              </div>
            </div>

            <div className="absolute inset-0 bg-gradient-to-br from-primary/0 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
          </a>
        ))}
      </div>
      <div className="mt-6 md:mt-8 p-4 md:p-6 rounded-lg bg-primary/5 border border-primary/20">
        <div className="flex items-start gap-3 md:gap-4">
          <Icon name="MessageCircle" size={24} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
          <div>
            <h4 className="text-base md:text-lg font-semibold mb-2">Stay Connected</h4>
            <p className="text-sm text-muted-foreground mb-4">
              Join the community of 50,000+ professionals following my journey across IT engineering, entrepreneurship, and creative direction.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">Tech Insights</span>
              <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">Business Tips</span>
              <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">Creative Content</span>
              <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">Mentorship</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaLinks;